/**
 * UI-facing pricing constants mirrored from the backend pricing
 * engine. These exist ONLY for badge labels and the "free quota"
 * visual affordance — the SPA never computes a price using these
 * values. The server-authoritative price comes from
 * `/api/v1/client-portal/pricing/preview` (live quote) and finally
 * from `/api/v1/intake/checkout` (the amount Stripe actually
 * charges).
 *
 * If the backend rate card changes, update this file in the same
 * commit. The numbers are duplicated, not derived from the API
 * payload, because the labels need to render before any backend
 * call lands — but the dollar AMOUNTS in the order summary always
 * come from the live quote, not from this file.
 *
 * Source of truth: apps/api/app/services/pricing.py
 *   RECON_BASE_ASSESSMENT_CENTS            = 24_900  ($249)
 *   RECON_SUBDOMAIN_FREE_THRESHOLD         = 5
 *   RECON_EXTRA_SUBDOMAIN_CENTS            = 1_500   ($15)
 *   RECON_EXTRA_DOMAIN_CENTS               = 17_500  ($175)
 *   RECON_EXTRA_IP_CENTS                   = 17_500  ($175)
 */

/** First N subdomains per primary domain are included in the base price. */
export const RECON_SUBDOMAIN_FREE_THRESHOLD = 5;

/** Human-readable label for the per-extra-subdomain add-on rate. */
export const EXTRA_SUBDOMAIN_PRICE_LABEL = "$15";

/** Human-readable label for the per-extra-domain and per-IP add-on rate. */
export const EXTRA_ASSET_PRICE_LABEL = "$175";

/** Human-readable label for the base Quick Check price. */
export const BASE_PRICE_LABEL = "$249";
